import React from 'react';
import { FormattedMessage } from 'translations';
import InteractiveInfoBlock from 'app/components/base/InteractiveInfoBlock';
import _noop from 'lodash/noop';
import { UPGRADE_IDS } from 'app/constants';


import style from './style.css';

// Constants
const messages = {
  title: { id: 'BOOK_TRIP.MEET_AND_GREET.TITLE' },
  weAddedOption: { id: 'BOOK_TRIP.MEET_AND_GREET.WE_ADDED_OPTION' },
  checkOtherTrips: { id: 'BOOK_TRIP.MEET_AND_GREET.CHECK_OTHER_TRIPS' },
  notIncluded: { id: 'BOOK_TRIP.MEET_AND_GREET.NOT_INCLUDED_INFO' },
  buttonOk: { id: 'BOOK_TRIP.MEET_AND_GREET.BUTTON_OK' },
  buttonNo: { id: 'BOOK_TRIP.MEET_AND_GREET.BUTTON_NО' }
};

class MeetAndGreetBox extends React.Component {

  state = {
    closed: false,
    showNotIncludedInfo: false
  }

  componentDidMount() {
    const {
      meetAndGreetAvailable,
      meetAndGreetChosen,
      toggleOptionalAmenity
    } = this.props;

    // include option by default
    if (meetAndGreetAvailable && !meetAndGreetChosen) {
      toggleOptionalAmenity(UPGRADE_IDS.MEET_AND_GREET);
    }
  }


  handleClose = () => {
    const {
      meetAndGreetAvailable,
      meetAndGreetChosen,
      toggleOptionalAmenity,
      onClickNo = _noop
    } = this.props;

    this.setState({ showNotIncludedInfo: true });
    onClickNo();

    if (meetAndGreetAvailable && meetAndGreetChosen) {
      toggleOptionalAmenity(UPGRADE_IDS.MEET_AND_GREET);
    }
  }

  handleCloseNotIncludedInfo = () => {
    this.setState({ closed: true, showNotIncludedInfo: false });
  }

  handleClickOk = () => {
    const { onClickOk = _noop } = this.props;

    onClickOk();

    this.setState({ closed: true, showNotIncludedInfo: false });
  }

  render() {
    const {
      meetAndGreetAvailable,
      meetAndGreetChosen
    } = this.props;

    const buttons = [
      {
        title: <FormattedMessage {...messages.buttonNo} />,
        onClick: this.handleClose
      },
      {
        title: <FormattedMessage {...messages.buttonOk} />,
        onClick: this.handleClickOk
      }
    ];

    const text = !meetAndGreetAvailable
      ? <FormattedMessage {...messages.checkOtherTrips} />
      : <FormattedMessage {...messages.weAddedOption} />;

    const componentAfterClosing = meetAndGreetChosen
      ? null
      : <InteractiveInfoBlock
        type="yellow"
        text={<FormattedMessage {...messages.notIncluded} />}
        className={style.block}
        onClickClose={this.handleCloseNotIncludedInfo}
      />;

    const mainInfo = (
      <InteractiveInfoBlock
        type="blue"
        title={<FormattedMessage {...messages.title} />}
        text={text}
        buttons={buttons}
        icon={{ family: 'mozio', name: 'meet-and-greet2' }}
        className={style.block}
        buttonsOnNextLine
      />
    );

    if (this.state.closed) return null;

    return (
      this.state.showNotIncludedInfo
        ? componentAfterClosing
        : mainInfo
      );
  }
}

// TODO: move to Flow types
// MeetAndGreetBox.propTypes = {
//   onClickOk: PropTypes.func,
//   onClickNo: PropTypes.func,
//   meetAndGreetAvailable: PropTypes.bool,
//   toggleOptionalAmenity: PropTypes.func,
//   meetAndGreetChosen: PropTypes.bool
// };

export default MeetAndGreetBox;
